let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("coHip")).then(() => parcelRequire('b85cr'));